import './ClosedRequestsRow.css';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import * as Icon from 'react-bootstrap-icons';
import Swal from 'sweetalert2';
import ClientDetails from '../ClientDetails/ClientDetails';

const ClosedRequestsRow = (props) => {
  const dispatch = useDispatch();
  const request = useSelector((store) => store.requestReducer.closed);
  const [clientDetails, setClientDetails] = useState({});
  const [clientModal, setClientModal] = useState(false);

  const handleShowClientModal = () => {
    setClientModal(true);
  }

  const deleteRequest = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this request',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        dispatch({ type: 'DELETE_REQUEST', payload: id })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Referral NOT deleted'
        )
      }
    })
  }
  const returnPendingRequest = (id) => {
        Swal.fire({
      title: 'Are you sure?',
      text: 'You will be moving client to pending',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, move it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
        dispatch({ type: 'RETURN_REQUEST', payload: id })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Referral NOT moved'
        )
      }
    })
  }
  function timeConverter(timestamp) {
    const time = new Date(timestamp);
    const fd = new Intl.DateTimeFormat('en-us').format(time);
    return fd.toString();
  }

  const displayDetails = (client) => {
    setClientDetails(client);
    handleShowClientModal();
  }

  useEffect(() => {
    dispatch({ type: 'FETCH_REQUESTS' });
  }, []);
    return(
      <tbody>
      <ClientDetails
        clientModal={clientModal}
        setClientModal={setClientModal}
        client={clientDetails}
      /> 
            {props.searchResults.map(request => (
        <tr key={request.id}>
          <td scope="row" className="text-center px-0 mx-0">{timeConverter(request.referral_date)}</td>
          <td scope="row" className="text-center px-0 mx-0">{timeConverter(request.appt_date)}</td>
          <td scope="row" className="text-center px-0 mx-0">{request.name}</td>
          <td width="30%" scope="row" className="text-center px-0 mx-0">{request.request_items}</td>
          <td scope="row" className="text-center px-0 mx-0">{request.referral_partner}</td>
          <td scope="row" className="text-center px-0">
            <Icon.InfoSquare
              className="mx-1"
              type="button"
              color="royalblue" size={30}
              onClick={() => {
                displayDetails(request)
              }}
            />
            <Icon.ArrowLeftCircle
              className="ml-1"
              type="button"
              color="blue" size={30}
              onClick={() => returnPendingRequest(request.id)}
            />
            <Icon.Trash
              className="ml-1"
              type="button"
              color="red" size={30}
              onClick={() => deleteRequest(request.id)}
            />
          </td>
        </tr>
      ))} 
      </tbody>
    );
}

export default ClosedRequestsRow;